import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { BaseElement, customElement, watch } from '../base-element';

import styles from './segmented-control-item.scss?inline';

export const tagName = 'ps-segmented-control-item';

/**
 * @summary A single option within a `<ps-segmented-control>`.
 *
 * @slot - The item label.
 * @slot prefix - Optional content before the label (e.g. a status dot).
 */
@customElement('ps-segmented-control-item')
export class SegmentedControlItemWC extends BaseElement {
  static styles = unsafeCSS(styles);

  /** The value assigned to this item, matched against the group's `value`. */
  @property({ reflect: true }) value = '';

  /** Whether this item is the selected one (managed by the group). */
  @property({ type: Boolean, reflect: true }) active = false;

  /** Disables the item and prevents selection. */
  @property({ type: Boolean, reflect: true }) disabled = false;

  connectedCallback() {
    // eslint-disable-next-line wc/guard-super-call
    super.connectedCallback();
    this.setAttribute('role', 'radio');
  }

  @watch('active')
  handleActiveChange() {
    this.setAttribute('aria-checked', this.active ? 'true' : 'false');
  }

  render() {
    return html`
      <button
        type="button"
        class=${classMap({
          'c-segmented-control-item': true,
          'c-segmented-control-item--active': this.active,
        })}
        ?disabled=${this.disabled}
        tabindex=${this.active ? '0' : '-1'}
        part="button"
      >
        <slot name="prefix"></slot>
        <span class="c-segmented-control-item__label"><slot></slot></span>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-segmented-control-item': SegmentedControlItemWC;
  }
  enum PSElementTagNameMap {
    'ps-segmented-control-item' = 'ps-segmented-control-item',
  }
}
